import React, { ReactNode } from "react";

import "../../assets/stylesheets/main.scss";
import "../../styles/app.css";
import logo from "../../assets/images/logo.png";
import {
  EnvironmentConfig,
  EnvironmentContext,
  ThemeConfig,
} from "./environment";

const landingPage = "https://welcome.hivewatch.ch";

const themeConfig: ThemeConfig = {
  logo,
  logoSmall: logo,
  appName: "HiveWatch",
  landingPage,
  tosUrl: landingPage + "/agb-online",
  supportUrl: "https://www.hivewatch.ch/hivewatch-manual-v2-download-page",
  shopFeatures: true,
};

type HivewatchThemeProps = {
  conf: EnvironmentConfig;
  children: ReactNode;
};
export default ({ conf, children }: HivewatchThemeProps) => (
  <EnvironmentContext.Provider value={{ ...conf, ...themeConfig }}>
    {children}
  </EnvironmentContext.Provider>
);
